import { render, staticRenderFns } from "./recommendStatus.vue?vue&type=template&id=3a97c168&"
import script from "./recommendStatus.vue?vue&type=script&lang=js&"
export * from "./recommendStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports